import { brandConstants } from 'brand-config';

import BristolWestLogo from './assets/bristol-west-logo.svg';
import CincinnatiLogo from './assets/cincinnati-logo.svg';
import CsaaLogo from './assets/csaa-logo.svg';
import DairylandLogo from './assets/dairyland-logo.svg';
import GrangeLogo from './assets/grange-logo.svg';
import HartfordLogo from './assets/hartford-logo.svg';
import MercuryLogo from './assets/mercury-logo.svg';
import NationalGeneralLogo from './assets/national-general-logo.svg';
import NationwideLogo from './assets/nationwide-logo.svg';
import OpenlyLogo from './assets/openly-logo.svg';
import ProgressiveLogo from './assets/progressive-logo.svg';
import SafecoLogo from './assets/safeco-logo.svg';
import TravelersLogo from './assets/travelers-logo.svg';
import LemonadeLogo from './assets/lemonade-logo.svg';
import PlymouthRockLogo from './assets/plymouth-rock-logo.svg';
import StillwaterLogo from './assets/stillwater-logo.svg';
import AnnexRiskLogo from './assets/annex-logo.svg';
import UnaLogo from './assets/una-logo.png';
import SageSureLogo from './assets/sage-sure-logo.png';
import ConcordLogo from './assets/concord-logo.svg';
import AmericanIntegrityLogo from './assets/american-integrity-logo.png';
import OlympusLogo from './assets/olympus-logo.png';

export const buildQuinstreetQuoteFromPolicy = ({ policy, fname, lname, list }) => {
  return {
    id: policy.id,
    webUserId: policy.webUserId,
    quote: {
      fname,
      lname,
      cars: policy.policyDetails.cars,
      drivers: policy.policyDetails.drivers || policy.policyDetails.people,
      monthsAtCurrentAddress: policy.policyDetails.monthsAtCurrentAddress || policy.offer.quote.monthsAtCurrentAddress,
      home: policy.offer.quote.home,
      autoCoverage: policy.policyDetails.autoCoverage,
      homeCoverage: policy.policyDetails.homeCoverage,
      correctedAddress: policy.offer.quote.correctedAddress,
      priorAddress: policy.offer.quote.priorAddress,
      multiPolicyDiscount: policy.policyDetails.multiPolicyDiscount,
      scheduledPersonalProperty: policy.policyDetails.scheduledPersonalProperty,
      global: {
        currentlyInsured: true,
        currentAutoCarrier: brandConstants.FULL_NAME,
        continuousAutoCoverageStartDate: list.find((policy) => policy.id.includes('auto-001'))?.effectiveDate,
        priorIndividualBILimit: policy.policyDetails.autoCoverage
          ? parseInt(policy.policyDetails.autoCoverage.policyLimitBIPD.split('/')[0], 10) * 1000
          : null,
        priorOccurrenceBILimit: policy.policyDetails.autoCoverage
          ? parseInt(policy.policyDetails.autoCoverage.policyLimitBIPD.split('/')[1], 10) * 1000
          : null,
        homeEffectiveDate: policy.effectiveDate
      }
    }
  };
};

export const CarrierData = {
  asi: {
    logo: ProgressiveLogo,
    url: 'https://www.foragentsonly.com/login/',
    H: {
      default: {
        newBusiness: 13,
        renewal: 13
      }
    }
  },
  cinc: {
    logo: CincinnatiLogo,
    url: 'https://www.cinfin.com/',
    A: {
      default: {
        disclaimer: 'Commissions and renewals may vary based on state, coverages, and covered individuals'
      }
    },
    H: {
      default: {
        disclaimer: 'Commissions and renewals may vary based on state, coverages, and covered individuals'
      }
    }
  },
  csaa: {
    logo: CsaaLogo,
    url: 'https://csaa-insurance.aaa.com/',
    A: {
      default: {
        newBusiness: 11,
        renewal: 8.5
      }
    },
    H: {
      default: {
        newBusiness: 15,
        renewal: 15
      }
    }
  },
  dryl: {
    logo: DairylandLogo,
    url: 'https://agent.dairylandagent.com/',
    A: {
      default: {
        newBusiness: 11,
        renewal: 9
      }
    }
  },
  fobl: {
    logo: BristolWestLogo,
    url: 'https://www.iaproducers.com',
    A: {
      default: {
        newBusiness: 15,
        renewal: 12.5
      }
    }
  },
  grng: {
    logo: GrangeLogo,
    url: 'https://www.grangeinsurance.com/',
    A: {
      default: {
        newBusiness: 12,
        renewal: 10
      }
    },
    H: {
      default: {
        newBusiness: 17,
        renewal: 15
      }
    }
  },
  hart: {
    logo: HartfordLogo,
    url: 'https://www.thehartford.com/'
  },
  merc: {
    logo: MercuryLogo,
    url: 'https://www.mercuryinsurance.com/',
    A: {
      default: {
        newBusiness: 16,
        renewal: 14
      }
    },
    H: {
      default: {
        newBusiness: 15,
        renewal: 15
      }
    }
  },
  ngen: {
    logo: NationalGeneralLogo,
    url: 'https://nationalgeneral.com/',
    A: {
      default: {
        newBusiness: 15,
        renewal: 15
      }
    },
    H: {
      default: {
        newBusiness: 15,
        renewal: 15
      }
    }
  },
  ngc3: {
    logo: NationalGeneralLogo,
    url: 'https://nationalgeneral.com/',
    A: {
      default: {
        newBusiness: 15,
        renewal: 15
      }
    },
    H: {
      default: {
        newBusiness: 15,
        renewal: 15
      }
    }
  },
  nwid: {
    logo: NationwideLogo,
    url: 'https://www.nationwide.com/',
    H: {
      default: {
        newBusiness: 15,
        renewal: 10
      },
      FL: {
        newBusiness: 10,
        renewal: 10
      }
    },
    A: {
      default: {
        newBusiness: 15,
        renewal: 10
      }
    }
  },
  open: {
    logo: OpenlyLogo,
    url: 'https://portal.openly.com/',
    H: {
      MA: {
        newBusiness: 14,
        renewal: 12
      },
      CT: {
        newBusiness: 14,
        renewal: 12
      },
      default: {
        newBusiness: 12,
        renewal: 12
      }
    }
  },
  prog: {
    logo: ProgressiveLogo,
    url: 'https://www.foragentsonly.com/login/',
    A: {
      default: {
        newBusiness: 9,
        renewal: 9
      }
    }
  },
  safe: {
    logo: SafecoLogo,
    url: 'https://www.safeco.com/',
    A: {
      default: {
        newBusiness: 14,
        renewal: 15
      }
    },
    H: {
      default: {
        newBusiness: 14,
        renewal: 15
      }
    }
  },
  trvl: {
    logo: TravelersLogo,
    url: 'https://www.travelers.com/',
    A: {
      default: {
        newBusiness: 15,
        renewal: 12
      }
    },
    H: {
      default: {
        newBusiness: 18,
        renewal: 15
      }
    }
  },
  trav: {
    logo: TravelersLogo,
    url: 'https://www.travelers.com/',
    A: {
      default: {
        newBusiness: 15,
        renewal: 12
      }
    },
    H: {
      default: {
        newBusiness: 18,
        renewal: 15
      }
    }
  },
  lemo: {
    logo: LemonadeLogo,
    url: 'https://www.lemonade.com/',
    H: {
      default: {
        newBusiness: 15,
        renewal: 10
      }
    }
  },
  pr: {
    logo: PlymouthRockLogo,
    url: 'https://www.plymouthrock.com/'
  },
  sw: {
    logo: StillwaterLogo,
    url: 'https://stillwaterinsurance.com/',
    A: {
      default: {
        newBusiness: 10,
        renewal: 10
      }
    },
    H: {
      default: {
        newBusiness: 12,
        renewal: 12
      }
    }
  },
  annexrisk: {
    logo: AnnexRiskLogo,
    url: 'https://www.annexrisk.com/',
    H: {
      default: {
        newBusiness: 10,
        renewal: 10
      }
    }
  },
  unam: {
    logo: UnaLogo,
    url: 'https://www.uihna.com/Agent/AgencyNewsTab.aspx',
    H: {
      CA: {
        newBusiness: 15,
        renewal: 14
      },
      FL: {
        newBusiness: 10,
        renewal: 8
      },
      NC: {
        newBusiness: 15,
        renewal: 13
      },
      NV: {
        newBusiness: 15,
        renewal: 14
      },
      SC: {
        newBusiness: 15,
        renewal: 13
      },
      TX: {
        newBusiness: 15,
        renewal: 13
      },
      default: {
        newBusiness: 15,
        renewal: 13
      }
    }
  },
  sage: {
    logo: SageSureLogo,
    url: 'https://agents.sagesure.com/login.html?redirect=/home',
    H: {
      default: {
        newBusiness: 14,
        renewal: 14
      }
    }
  },
  cgin: {
    logo: ConcordLogo,
    url: 'https://www.aoins.com/my.policy',
    A: {
      default: {
        newBusiness: 15,
        renewal: 15
      }
    },
    H: {
      default: {
        newBusiness: 20,
        renewal: 20
      }
    }
  },
  aiic: {
    logo: AmericanIntegrityLogo,
    url: 'https://ai.iscs.com/innovation?rndtk=1431360304',
    H: {
      default: {
        newBusiness: 12,
        renewal: 8
      }
    }
  },
  olym: {
    logo: OlympusLogo,
    url: 'https://pm.oiconnect.com/sign-in',
    A: {
      default: {
        newBusiness: 9,
        renewal: 7
      }
    },
    H: {
      default: {
        newBusiness: 9,
        renewal: 7
      }
    }
  }
};

export const getCarrierCommissions = (carrier, state, policyType) => {
  return CarrierData[carrier]?.[policyType]?.[state] || CarrierData[carrier]?.[policyType]?.default;
};
